module.exports = __webpack_public_path__ + "media/images/categories/headers/banking-and-finance-016f6a34a01176ed77deb572559e1024.jpg";